import { QueryClient } from '@tanstack/react-query'
import { UnauthorizedError } from '@/api/helpers'
import { MINUTES } from '@/constants'
import { createIDBPersister } from './persister'

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * MINUTES,
			retry: (failureCount, error) => {
				if (error instanceof UnauthorizedError) return false
				if (failureCount > 2) return false
				return true
			},
		},
	},
})

const persister = createIDBPersister('reactQuery')

export async function clearPersistedQueries(): Promise<void> {
	queryClient.clear()
	await persister.removeClient()
}
